import {useState} from 'react';

import {Button, Modal} from '@/components';

export default function ConfirmTierChangeModal({
  isOpen,
  title,
  confirmLabel,
  loadingText,
  isDestructive = false,
  children,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  title: string;
  confirmLabel: string;
  loadingText: string;
  isDestructive?: boolean;
  children: React.ReactNode;
  onClose: () => void;
  onConfirm: () => Promise<boolean>;
}) {
  const [isSaving, setIsSaving] = useState(false);

  const handleConfirm = async () => {
    setIsSaving(true);
    try {
      if (await onConfirm()) {
        onClose();
      }
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="w-11/12 md:w-6/12 lg:w-4/12 px-4 sm:px-0"
      title={title}
      zIndex={60}
      closeOnOutsideClick
    >
      <div className="space-y-4">
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
          {children}
        </div>
        <div className="flex justify-end gap-3">
          <Button variant="ghost" colorScheme="cyan" onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme={isDestructive ? 'red' : 'cyan'}
            isLoading={isSaving}
            loadingText={loadingText}
            onClick={handleConfirm}
            data-testid="affiliate-tier-confirm"
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
